<!-- <div class="relative z-10 text-center px-4 mt-10">
    <h1 class="font-medium text-black text-xl md:text-2xl mb-4">Terms & Conditions</h1>
</div> -->
<div class="min-h-screen bg-white text-[#0A0A0A]">
<div class="max-w-6xl mx-auto my-8 px-4 sm:px-6 lg:px-8">
    <div class="prose prose-sm max-w-none text-[#0A0A0A] leading-relaxed">

        <div class="mb-6">
            <p class="text-sm text-justify mb-3">
                This agreement is made as part of an online application (the "Application") for participation in the
                Varroc Connect site, applications (the "Apps") and any services or products (the "Services") provided by
                Varroc Connect Private Limited ("Varroc Connect") on or in connection with the Varroc Connect Site and
                includes, in addition to the terms set forth below, all rules and policies for participating in the
                Services provided on the Varroc Connect Site, the Terms and Conditions, the Varroc Connect Privacy
                Policy (collectively, this "Agreement").
            </p>

            <p class="text-sm text-justify mb-3">
                This Agreement is a binding agreement between Varroc Connect and you with respect to your participation
                (the "User") in the Services and your consumption of Services through the Varroc Connect Site and Apps.
                If the User is an Entity, the individual person who accepts this Agreement represents and warrants that
                he or she is entitled to enter this Agreement as an authorized representative of the Entity and to bind
                the Entity to the terms of this Agreement.
            </p>

            <p class="text-sm text-justify mb-4">
                By accessing or using the Services, you acknowledge that you have read, understood, and agree to be
                bound by this Agreement. If you do not agree, you must not use the Services.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">General Terms Applicable to all Users</h3>

            <h4 class="font-medium text-base mb-2 text-black">Account Responsibility</h4>
            <p class="text-sm text-justify mb-3">
                The User is responsible for maintaining the confidentiality of the User's account ID and password and
                the User accepts responsibility for all activities that occur under the User's account or password. The
                User, if an individual, affirms that he or she is competent to understand, enter into, and comply with
                these Terms and Conditions, and (ii) is not under 18 years of age. Where the User is 18 years of age or
                older but is not of the age of majority in the User's jurisdiction of residence (a "Minor"), the User
                may not use certain Services or access certain portions of the Services, as determined by Varroc Connect
                in its sole discretion from time to time, except under the supervision of a parent or guardian who is
                also a User and who is not a Minor. For example, Users may not purchase or order any materials from the
                Varroc Connect Site and will generally only be able to access features granted to them by a parent or
                guardian.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Changes to these Terms and Conditions</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect reserves the right to modify, amend, or update these Terms and Conditions by advising the
                User of the proposed change using a form of notice that is appropriate for the nature of the proposed
                change(s), including where appropriate by posting amended Terms and Conditions on the Varroc Connect
                Site. The changes are effective on the later of (i) the date specified in a notice delivered by Varroc
                Connect to the User advising of such changes (which message may be delivered by email, messaging, or
                other electronic means), or (ii) 14 days after the amended Terms and Conditions are posted on the Varroc
                Connect Site. If the User does not agree to the amended Terms and Conditions, the User may no longer use
                the Varroc Connect Site or the Services after the effective date of the amendment.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Privacy Policy</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect Private Limited ("Varroc Connect," "we," "us," or "our") is committed to protecting the
                privacy and personal information of Users ("you" or "User"). By providing information to Varroc Connect,
                the User consents to the use of such personal information in accordance with the Privacy Policy.
            </p>

            <p class="text-sm text-justify mb-3">
                Varroc Connect is committed to protecting your privacy and earning and keeping your trust. We respect
                your privacy and are dedicated to earning and maintaining your trust by safeguarding your data and using
                it responsibly. This Privacy Policy explains what information we collect, how we use it, and the choices
                you have regarding your data.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Data Collected/Usage</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect collects information transmitted by the mobile-based telematics system, including but not
                limited to Global Positioning System (GPS) data and accelerometer readings. This data may include
                location, movement patterns, speed, and other sensor-based metrics necessary for the provision of our
                services.
            </p>

            <p class="text-sm text-justify mb-3">
                <strong>User Responsibility:</strong> Users must ensure their mobile device has adequate battery,
                permissions, and network connectivity to allow for uninterrupted data capture and transfer. Varroc
                Connect is not responsible for any loss of service due to user-side configuration or connectivity
                issues. Users are solely responsible for granting all necessary permissions for data collection and for
                maintaining device settings required to use the Services.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Refund Policy</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect does not provide refunds for any subscription (including charged services), service, or
                service charges once payment has been successfully processed, except as required by applicable laws and
                regulations. Users are strongly encouraged to thoroughly evaluate the application's features and
                compatibility during any available trial period (if available) before proceeding with a purchase or
                subscribing to any paid services. All requests for refunds must be submitted in writing and will be
                considered on a case-by-case basis in accordance with Varroc Connect's refund evaluation procedures.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Use of the Varroc Connect Site/Service</h4>
            <p class="text-sm text-justify mb-3">
                Effective upon Varroc Connect's acceptance of a User's request to become a registered User of the Varroc
                Connect Site and provided that the User continues to comply with these Terms and Conditions, Varroc
                Connect grants to the User a personal, non-assignable, non-transferable, and limited license to log into
                and access the Varroc Connect Site, access content made publicly available on the Varroc Connect Site
                (the "Public Content"). Any breach of express license restrictions on any of the Site Content may lead
                to termination of a User's account and his/her further access to the Varroc Connect Site and the
                Services.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Cancellation Policy</h4>
            <p class="text-sm text-justify mb-3">
                Users may cancel their subscription or service by providing a 90-day notice period. Upon cancellation,
                users are required to pay the upfront subscription charges for the 90-day (3-month) notice period. The
                subscription will terminate on the last day of the 90-day notice period.
            </p>

            <p class="text-sm text-justify mb-3">
                Following cancellation, any user data associated with the subscription will be retained for a period as
                specified in our data retention policy. Users may request the deletion of their data, in accordance with
                applicable laws, prior to the end of the notice period. Upon completion of the cancellation process, and
                where required by law, we will delete the user's data in a secure manner. Access to real-time app
                features will be restricted.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Termination of Access</h4>
            <p class="text-sm text-justify mb-3">
                If the User uses the Varroc Connect Site in any manner that is prohibited by these Terms and Conditions,
                Varroc Connect may without notice terminate or suspend the User's use of or access to the Varroc Connect
                Site or the Services.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Support in Case of Cancellation</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect will provide reasonable support during the cancellation process, including access to
                helpdesk channels for resolving any service or billing issues. Users may contact support at <a
                    (click)="openEmail(SupportEmail)"
                    class="text-blue-600 hover:text-blue-800 underline cursor-pointer">{{SupportEmail}}</a> for assistance.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Changes to the Varroc Connect Site and Services</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect reserves the right to change any aspect of the Varroc Connect Site or the Services
                including the right to refuse or remove any part of the Site Content, whatever the source, at any time
                without any notice or liability to the User.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Prohibited Use of the Varroc Connect Site</h4>
            <p class="text-sm text-justify mb-3">
                The User may not use the Varroc Connect Site to engage in any unlawful activity or to infringe the
                rights of Varroc Connect, its affiliates, or its customers, or any third party. The User will not (and
                will not allow the User's employees or agents to):
            </p>

            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">interfere with the operation of the Varroc Connect Site or the Services in any way,
                    or interfere with anyone's use or enjoyment of the Varroc Connect Site or the Services, or use the
                    Varroc Connect Site or the Services to gain unauthorized access to other computer systems;</li>
                <li class="text-sm">send chain letters, junk mail, or spam or use any distribution lists in respect of
                    any person who has not given specific permission to be included in such a process or to distribute
                    or publish advertisements or solicitations of business other than such communications expressly
                    permitted by Varroc Connect;</li>
                <li class="text-sm">broadcast, publish or transmit any unlawful, harassing, libellous, defamatory,
                    abusive, threatening, or harmful material of any kind or broadcast, publish or transmit any material
                    that encourages conduct that could constitute a criminal offence, give rise to civil liability, or
                    otherwise violate any applicable local, provincial, state, national or international law or
                    regulation;</li>
                <li class="text-sm">impersonate any person or entity on or through the Varroc Connect Site;</li>
                <li class="text-sm">post any content that infringes or misuses any copyright or other right of any
                    person, or may be considered threatening, abusive, vulgar, obscene, or otherwise objectionable;</li>
                <li class="text-sm">reverse assemble, reverse engineer, decompile, or otherwise attempt to derive source
                    code from the software used in the Varroc Connect Site or any component thereof (except as permitted
                    under applicable local law after having given Varroc Connect written notice of requiring such
                    information or specifications for the good faith and reasonable purpose of interoperability);</li>
                <li class="text-sm">copy, reproduce, modify, sell, lease, scrape content from or aggregate, sublicense,
                    market, or otherwise change or commercially exploit in any way the Varroc Connect Site or the Site
                    Content or the Services or any component thereof other than as may be expressly permitted by Varroc
                    Connect or as permitted by applicable laws;</li>
                <li class="text-sm">disclose the User's password or otherwise grant access to the Varroc Connect Site to
                    any third party, other than the User's authorized agent.</li>
            </ul>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Operation and Maintenance of the Varroc Connect Site</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect operates the Varroc Connect Site in a commercially reasonable manner and may from time to
                time interrupt the Varroc Connect Site's services for regular and emergency maintenance. Where Varroc
                Connect has advance knowledge of any interruption to the Services, Varroc Connect will make reasonable
                efforts to provide advance notice to the User of any such interruption.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Monitoring Use of the Varroc Connect Site and Services
            </h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect may monitor the Varroc Connect Site but is under no obligation to do so. The User hereby
                waives any expectation of privacy in such information and activity. The User's waiver of rights in all
                such monitoring does not apply to personally identifiable information, which is handled by Varroc
                Connect in accordance with the Privacy Policy of the Varroc Connect Services.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Intellectual Property of Varroc Connect</h4>
            <p class="text-sm text-justify mb-3">
                The copyright to the Varroc Connect Site, the design and appearance of the Varroc Connect Site, and all
                of the material and the Site Content are owned by or licensed to Varroc Connect. This material is
                protected by law against unauthorized copying and reproduction. Any use, reproduction, or distribution
                of Site Content, including caching, framing, or similar means, from the Varroc Connect Site (except as
                permitted herein) without permission of Varroc Connect is expressly prohibited.
            </p>

            <p class="text-sm text-justify mb-3">
                <strong>Copyright 2013 and after Varroc Connect Private Limited. All rights reserved.</strong>
            </p>

            <p class="text-sm text-justify mb-3">
                Varroc Connect and other Varroc Connect graphics, logos, publication designs, and service names are
                trademarks of Varroc Connect or its affiliates or associates. All other trade-marks not owned by Varroc
                Connect or its affiliates that appear on the Varroc Connect Site are the property of their respective
                owners, who may or may not be affiliated with, connected to, or sponsored by Varroc Connect or its
                affiliates. The display of any trademarks on the Varroc Connect Site does not imply that a license has
                been granted for any further use.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Trademark License for Marketing, Promotion, and
                Distribution</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect (as "Licensor") hereby grants to the User (as "Licensee") a nonexclusive, non-royalty
                bearing, worldwide license to use its trademarks and logos and, in the case of User, the trademarks and
                logos of any of its affiliates and the licensors of User and its affiliates that are implementing Apps
                on the Varroc Connect Site to market, promote, distribute, and deliver Apps as contemplated by this
                Agreement. The Licensor may terminate or limit the foregoing license if, in the Licensor's reasonable
                discretion, the Licensee's use of the Licensor's Mark tarnishes, blurs or otherwise dilutes the quality
                or goodwill associated with the Marks and such use is not cured within ten (10) days of receipt of a
                written notice thereof.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Claims of Infringement</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect respects the intellectual property rights of others. If any person believes that their
                copyrighted work or other intellectual property rights have been infringed upon by content accessible on
                or through the Varroc Connect Site, Upon provision of a notification in accordance herein, Varroc
                Connect, in its discretion, may suspend access to such allegedly infringing content until resolution of
                the dispute between the rights holder and the alleged infringer.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">No Warranties and No Liability</h4>
            <p class="text-sm text-justify mb-3">
                The User acknowledges and agrees that the Varroc Connect Site and the Services are provided on an "as
                is", "without any warranties", and "without any liability" basis. The parties to these Terms and
                Conditions acknowledge and agree that this limitation on liability is reasonable in the circumstances.
            </p>

            <p class="text-sm text-justify mb-3">
                Varroc Connect does not guarantee the quality, accuracy, completeness, or timeliness of the Varroc
                Connect Site or the Services provided in connection therewith, which may contain errors. The User should
                not assume that the User's use of the Varroc Connect Site or the Services will be error free or that the
                Site will operate without interruption. Varroc Connect does not warrant that the Varroc Connect site,
                its servers, or any communication originating from the Varroc Connect site OR Varroc Connect are free of
                viruses, trojan horses, or other harmful components.
            </p>

            <p class="text-sm text-justify mb-3">
                Varroc Connect disclaims and excludes to the maximum extent permitted by applicable law all warranties,
                representations, and conditions regarding use of the Varroc Connect Site or the Services, including all
                implied warranties or conditions of merchantability, merchantable quality, fitness for a particular
                purpose, or non-infringement, whether express or implied and whether arising from a course of dealing,
                usage, or trade practice.
            </p>

            <p class="text-sm text-justify mb-3">
                Varroc Connect is not responsible for any indirect, special, incidental, consequential, or punitive
                damages whatsoever arising out of or in connection with the use or misuse of the Varroc Connect Site or
                the Services or in reliance on the Apps available on the Varroc Connect Site, including without
                limitation any business interruption, loss of use, lost data, lost profits, failure to realize expected
                savings, or any pecuniary loss, whether in an action of contract, civil liability, negligence, or other
                tortuous action, even if Varroc Connect has been informed of the possibility of such damages or such
                damages are reasonably foreseeable.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Limit on Damages and Claims</h4>
            <p class="text-sm text-justify mb-3">
                Notwithstanding any other provisions of these terms and conditions, the User acknowledges and agrees
                that under no circumstances shall the aggregate of Varroc Connect's liability exceed the fees actually
                paid by the User in respect of the Varroc Connect site.
            </p>

            <p class="text-sm text-justify mb-3">
                Any cause of action that the User may have arising out of or related to the Varroc Connect site or the
                services must commence within one (1) year after the cause of action accrues. Otherwise, unless and to
                the extent such limitation is prohibited by applicable laws, such cause of action is permanently barred.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Indemnity</h4>
            <p class="text-sm text-justify mb-3">
                The User hereby agrees to hold harmless and indemnify Varroc Connect and its officers, directors,
                employees, consultants, and agents from any and all third party claims, liability, damages, or costs
                they incur arising as a result of the User's misuse of the Varroc Connect Site & Services, the User's
                violation of these Terms and Conditions, or the User's infringement of any intellectual property or
                other right of Varroc Connect or any other person or entity, including such activities that are carried
                out by any individual using the User's account ID or password information.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Jurisdiction</h4>
            <p class="text-sm text-justify mb-3">
                Any dispute relating to the Varroc Connect Site or Services shall be governed by laws of India and shall
                be adjudicated only by the courts at Pune. Nothing in these Terms and Conditions shall prevent Varroc
                Connect from seeking injunctive or other equitable relief, payment of amounts due, or enforcement of an
                award before any court having jurisdiction over the User or otherwise over such subject matter. Varroc
                Connect makes no representation that the Varroc Connect Site or the Services are appropriate or
                available for use in all locations, and accessing the Varroc Connect Site from territories where the
                Varroc Connect Site or its content is illegal is prohibited. If the User chooses to access the Varroc
                Connect Site from such a location, the User does so, on the User's own initiative and the User is
                responsible for compliance with applicable local laws.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Specific Terms Applicable to Certain Users</h3>

            <h4 class="font-medium text-base mb-2 text-black">Type of Users</h4>
            <p class="text-sm text-justify mb-3">
                While all Users are subject to the General Terms above, certain Users are subject to further specific
                terms.
            </p>

            <p class="text-sm text-justify mb-3">The types of Users are:</p>
            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">"Purchaser" which means a User who places an Order;</li>
                <li class="text-sm">"Developer" which means a User who uploads Apps and makes such Apps available to the
                    public</li>
            </ul>

            <p class="text-sm text-justify mb-3">
                For greater certainty, a Developer may be a Purchaser as well, and a Purchaser who makes Apps publicly
                available on the Varroc Connect Site becomes a Developer.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Private Uploaded Apps</h4>
            <p class="text-sm text-justify mb-3">
                Apps which are not made publicly available on the Varroc Connect Site is referred to as "Private Apps".
                Subject to any other agreement between the Developer and Varroc Connect (i) the Developer represents and
                warrants that the Developer owns the Private App and all intellectual property rights and other rights
                therein or has obtained all license rights necessary to enable the relevant activities, (ii) the
                Developer is responsible for ensuring that the Developer has the right to provide the Private App to
                Varroc Connect for hosting and transmission with the Varroc Connect Site and the Services (to the extent
                applicable), and (iii) notwithstanding any disclaimers or limitations otherwise applicable in respect of
                the Private App, the Developer agrees to hold harmless and indemnify Varroc Connect for any liability
                arising from the Private App.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Published Apps</h4>
            <p class="text-sm text-justify mb-3">
                Subject to any other agreement between Developer and Varroc Connect (i) Developer represents and
                warrants that Developer owns the Published App and all intellectual property rights and other rights
                therein or has obtained all license rights necessary to enable the relevant activities, (ii) Developer
                is responsible for ensuring that Developer has the right to provide the Published App to Varroc Connect
                for hosting and transmission in connection with the Varroc Connect Site and the Services, and (iii)
                notwithstanding any disclaimers or limitations otherwise applicable in respect of the Published App, the
                Developer agrees to hold harmless and indemnify Varroc Connect for any liability arising from the
                Published App.
            </p>

            <p class="text-sm text-justify mb-3">
                By uploading or otherwise making available Published Apps, Developer grants to Varroc Connect the right
                to make available such Published Apps on the Varroc Connect Site and allow others to use the Published
                App as contemplated in these Terms and Conditions and in the applicable service and product
                descriptions.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Ownership of Uploaded Apps</h4>
            <p class="text-sm text-justify mb-3">
                Unless otherwise stated for specific Services, the Developer or its licensors will retain ownership of
                and all related rights in any original content provided by the Developer.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Fees</h4>
            <p class="text-sm text-justify mb-3">
                Subject to any licensing restrictions attached to any part of the Site Content, a User may view the
                Public Content on the Varroc Connect Site at no cost. Users will be responsible for paying all fees
                associated with applicable Services as clearly outlined on the Varroc Connect Site.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Taxes</h4>
            <p class="text-sm text-justify mb-3">
                Any Order which specifies delivery of shipment outside India may be subject to additional or other taxes
                or charges, all of which are the responsibility of the Purchaser.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Import Fees</h4>
            <p class="text-sm text-justify mb-3">
                Delivery of an Order may be subject to import taxes, customs duties, and fees levied by the country
                where the recipient receives shipment of the Order ("Import Fees"), which may include India in the
                circumstances where Varroc Connect uses a third-party service provider located outside India to ship the
                Order to the Purchaser. The Purchaser is responsible for all Import Fees and any additional charges for
                customs clearance. Varroc Connect has no control over and shall not be liable for these charges. Customs
                policies vary widely from country to country; a Purchaser should contact his/her local customs office
                for further information.
            </p>
        </div>

        <div class="mb-6">
            <h4 class="font-medium text-base mb-2 text-black">Risk of Loss</h4>
            <p class="text-sm text-justify mb-3">
                If an item ordered from Varroc Connect is substantially damaged in transit to the Purchaser, the
                Purchaser may request a replacement from Varroc Connect, at Varroc Connect's cost, provided that the
                Purchaser will, as directed by Varroc Connect, either return the item to Varroc Connect or destroy the
                item.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Data Transmission Undertaking</h3>
            <p class="text-sm text-justify mb-3">
                <strong>Please read the T&C for Data Transfer carefully</strong>
            </p>

            <h4 class="font-medium text-base mb-2 text-black">Account Responsibility</h4>
            <p class="text-sm text-justify mb-3">
                I understand and accept full responsibility for all the activities that occur under my user's account
                using the data transmission module. Further, I confirm that I am an individual above 18 years of age,
                competent to understand, and enter into, and comply with these conditions.
            </p>

            <p class="text-sm text-justify mb-3">
                I absolve Varroc Connect Private Limited of any litigation that may arise out of misuse of the data
                transmission module. I agree to indemnify and hold harmless Varroc Connect Private Limited from any
                claims, losses, or damages arising from such misuse.
            </p>
        </div>

        <div class="mb-6">
            <h3 class="font-semibold text-lg mb-3 text-black">Varroc Miles – Terms & Conditions</h3>

            <h4 class="font-medium text-base mb-2 text-black">Feature Description</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Miles is a rewards feature that allows users to earn miles based on their driving behaviour and
                distance travelled, as captured through the Varroc Connect telematics device or mobile-based telematics
                solution. The miles earned can be redeemed for coupons, partner offers, or other benefits as made
                available from time to time within the Varroc Connect app.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">1. Eligibility</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Miles are available only to registered users of the Varroc Connect platform who are actively
                using a connected telematics device or a mobile-based telematics solution. Varroc Miles can be earned
                only by individual B2C users (personal/private use). The program is not applicable for fleet,
                commercial, or corporate usage unless explicitly permitted by Varroc Connect in writing. Varroc Connect
                reserves the right to verify eligibility and may suspend or revoke Miles if any misuse, fraudulent
                activity, or violation of terms is detected. The existing users can accumulate the Varroc Miles only
                from the date of App update.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">2. Earning Varroc Miles</h4>
            <p class="text-sm text-justify mb-3">
                Users may earn Varroc Miles on following categories based on, but not limited to: distance driven, safe
                driving behaviour, and completion of in-app challenges or milestones. Driving parameters such as, but
                not limited to, smooth acceleration, safe braking, minimal idling, and consistent driving may contribute
                to higher rewards. Varroc Connect reserves the right to alter, suspend, or update the criteria and
                methodology for earning Varroc Miles at its sole discretion, with or without prior notice. No Varroc
                Miles will be earned for trips that are not captured due to device malfunction, inactive telematics
                device, lack of mobile network, or any other technical failure beyond Varroc Connect's reasonable
                control.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">3. Redemption of Varroc Miles</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Miles may be redeemed for coupons, offers from partners, or in-app features/accessories as listed
                within the app. Redemption options, thresholds, and availability are subject to change at the discretion
                of Varroc Connect and its partners. Once redeemed, Varroc Miles will be deducted from the user's account
                and cannot be reinstated or cancelled. All redemptions are final and non-refundable. Varroc Connect is
                not liable for partner-related issues, delays, or failures in reward fulfilment.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">4. Validity & Expiry</h4>
            <p class="text-sm text-justify mb-3">
                Unless otherwise specified, Varroc Miles will remain valid for Twelve (12) months from the date of
                accrual. Expired Varroc Miles will automatically lapse and cannot be reinstated. Users are responsible
                for tracking the validity of their Varroc Miles. For Varroc Miles linked to specific partner or
                third-party offers, validity may differ and will be subject to the partner's terms. If a user deletes
                the app, earned rewards will remain valid for 1 Year. If the app is reinstalled and used within this
                period, the user can continue to utilize the earned Miles. After this 1 Year window, any unutilized
                Miles will lapse. In case the user closes their account or removes the device, all earned Miles will be
                forfeited and cannot be redeemed.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">5. Non-transferable</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Miles cannot be exchanged for cash, sold, bartered, gifted, pooled, or transferred to another
                user under any circumstances. Varroc Miles are personal to the registered account holder and are
                strictly non-transferable.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">6. Limitations of use</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Miles cannot be earned during periods where trip data is unavailable due to:
            </p>
            <ul class="list-disc list-inside ml-3 mb-3 space-y-1">
                <li class="text-sm">Non-functionality or inactivity of the device,</li>
                <li class="text-sm">Poor or no network connectivity,</li>
                <li class="text-sm">Technical issues, or</li>
                <li class="text-sm">Any user actions that prevent data capture.</li>
            </ul>
            <p class="text-sm text-justify mb-3">
                Varroc Connect is not liable for Miles lost due to the above circumstances.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">7. Updates and availability of the feature</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect reserves the right to modify or discontinue the Varroc Miles program, in whole or in
                part, at any time, with or without prior notice. By continuing to use the app or participating in the
                program after updates, users are deemed to have accepted the revised terms.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">8. Dispute Resolution</h4>
            <p class="text-sm text-justify mb-3">
                Any disputes relating to earning, redemption, or validity of Varroc Miles shall be resolved by Varroc
                Connect, and such decision shall be final and binding. Users agree that courts in Pune, India shall have
                exclusive jurisdiction over any disputes arising under these Terms. These Terms shall be governed by and
                construed in accordance with the laws of India.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">9. Liability Disclaimer</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect shall not be responsible for: Expired Miles or coupons, Redemption failures due to
                third-party partners, Technical failures, network errors, or app/device malfunctions beyond Varroc's
                reasonable control. To the maximum extent permitted by law, Varroc Connect disclaims all warranties and
                liabilities arising out of or in connection with the Varroc Miles program. Varroc Connect shall not be
                liable for any delay or failure in performance due to force majeure events including natural disasters,
                government actions, telecom outages, cyber-attacks, or other causes beyond its reasonable control.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">10. Fraud and Misuse</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect may suspend or cancel Varroc Miles and/or user accounts in cases of suspected fraud,
                misuse, or manipulation, including tampering with telematics data or generating false trips.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">11. Right to Withhold Benefits</h4>
            <p class="text-sm text-justify mb-3">
                Redemptions may be withheld if a user's account is under investigation or found in violation of these
                Terms or the Privacy Policy.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">12. Partner Offers</h4>
            <p class="text-sm text-justify mb-3">
                Partner rewards are subject to third-party terms. Varroc Connect is not liable for partner failures or
                disputes.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">13. Data Usage</h4>
            <p class="text-sm text-justify mb-3">
                Driving data is used to calculate rewards and improve services, in accordance with the Privacy Policy
                and applicable law. By using the programme, users consent to such data use.
            </p>

            <h4 class="font-medium text-base mb-2 text-black">14. Force Majeure</h4>
            <p class="text-sm text-justify mb-3">
                Varroc Connect is not liable for delays or disruptions due to causes beyond its control (e.g. natural
                disasters, cyberattacks, telecom issues).
            </p>
        </div>

    </div>
</div>
</div>